import { useEffect, useState } from "react";
import { Main, Container } from "./styled";
import close_icone from "../../../../assets/icons/close.svg";
import InformacoesPlantio from './informacoes';
import { useNavigate } from "react-router-dom";
import ControllerPlantioModal from "./controller";
import DeleteDialog from "../../../components/DeleteDialog";
import Plantio from "../../../../models/Plantio";

function PlantioModal(props){
  const navigate = useNavigate();
  const closeModal = props.onClose;
  const plantio = props.plantio;
  const [confirmarExclusao, setConfirmarExclusao] = useState(false);
  const [erroExclusao, setErroExclusao] = useState("");

  const controllerPlantioModal = new ControllerPlantioModal();

  // Esc fecha, como em qualquer diálogo.
  useEffect(() => {
    const aoTeclar = (e) => { if (e.key === "Escape") closeModal(); };
    window.addEventListener("keydown", aoTeclar);
    return () => window.removeEventListener("keydown", aoTeclar);
  }, [closeModal]);

  async function excluirPlantio(){
    const result = await Plantio.deleteById(plantio.id);
    if(result?.status === 200){
      closeModal();
      props.onDeleted?.();
    }else{
      setErroExclusao(result?.response?.data?.error || "Não foi possível excluir o plantio. Tente novamente.");
    }
  }

  return(
    // Clicar fora do cartão fecha; clicar dentro não propaga.
    <Main onMouseDown={(e) => { if (e.target === e.currentTarget) closeModal(); }}>
      <Container role="dialog" aria-modal="true" aria-labelledby="plantio-titulo">
        <header className="topo">
          <span className="rotulo-modal">Informações do plantio</span>
          <button type="button" className="fechar" onClick={closeModal} aria-label="Fechar">
            <img src={close_icone} alt="" />
          </button>
        </header>

        {confirmarExclusao &&
          <DeleteDialog
            titulo="Excluir este plantio?"
            subtitulo="O plantio e suas mídias serão removidos de forma permanente."
            error={erroExclusao}
            textButton="Excluir"
            onDelete={excluirPlantio}
            onClose={()=>{ setConfirmarExclusao(false); setErroExclusao(""); }}
          />
        }

        <InformacoesPlantio
          plantio={plantio}
          previousImage={()=>controllerPlantioModal.previousImage()}
          nextImage={()=>controllerPlantioModal.nextImage()}
        />

        <div className="bottom">
          <button type="button" className="secundario" onClick={closeModal}>Fechar</button>
          <button type="button" className="secundario" onClick={()=>setConfirmarExclusao(true)}>Excluir plantio</button>
          <button type="button" onClick={()=>navigate(`/minhas-arvores/atualizar/${plantio.id}`)}>Atualizar plantio</button>
        </div>
      </Container>
    </Main>
  );
};

export default PlantioModal;
